import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import styled from "styled-components";
import { ReactSVG } from "react-svg";
import { toast } from "react-toastify";

import api from "../../../../../services/api";
import Modal from "../../../../../components/Modal";
import FrontCredito from "../../../../../assets/navbar/Front_Credito_on_light_blue.svg";
import SearchableSelect from "../../../../../components/SearchableSelect";
import SearchableMultipleSelect from "../../../../../components/SearchableMultipleSelect";
import Input from "../../Input";
import Button from "../../../../../components/Button-v2";
import { Card, Label } from "../../styles";
import MotivoRejeicao from "../../../../../services/motivos-rejeicao";
import { size } from "lodash";

const selectLabelStyles = {
  paddingBottom: "3.3px",
  lineHeight: 1.17,
  fontWeight: "normal",
  fontSize: "12px",
  opacity: 0.9,
};

const OpinionsModal = (props) => {
  const {
    cpfCnpj,
    proposalNumber,
    opinionTypes,
    opinionTypesLoading,
    decisions,
    open,
    onClose,
    reloadOpinions,
    reloadEvents,
    proposalPossibleStatuses,
    proposalPossibleStatusesLoading,
    reloadProposalPossibleStatuses,
    proposalGroupCode,
  } = props;

  const [denyReasons, setDenyReasons] = useState([]);
  const [selectedDecision, setSelectedDecision] = useState(undefined);
  const [selectedOpinionType, setSelectedOpinionType] = useState(undefined);
  const [selectedDenyReason, setSelectedDenyReason] = useState(undefined);
  const [selectedAlternative, setSelectedAlternative] = useState(undefined);
  const [selectedProposalStatus, setSelectedProposalStatus] =
    useState(undefined);
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [denyReasonsLoading, setDenyReasonsLoading] = useState(false);
  const [requiredStatus, setRequiredStatus] = useState(false);
  const [requiredDenyReason, setRequiredDenyReason] = useState(false);
  const [selectedDenyReasons, setSelectedDenyReasons] = useState([]);
  const [selectedAlternatives, setSelectedAlternatives] = useState({});

  const handleClose = () => {
    setSelectedOpinionType(undefined);
    setSelectedDecision(undefined);
    setSelectedProposalStatus(undefined);
    setRequiredStatus(false);
    setNote(undefined);
    onClose();
  };

  const handleChangeDecision = (decision) => {
    setSelectedDecision(decision);
    if (decision.value === 3) {
      setRequiredStatus(true);
      setSelectedProposalStatus(undefined);
    } else {
      setRequiredStatus(false);
    }

    if (
      decision.value === 2 &&
      (proposalGroupCode === 101 || proposalGroupCode === 44)
    ) {
      setRequiredDenyReason(true);
    } else {
      setRequiredDenyReason(false);
      setSelectedDenyReason(undefined);
      setSelectedAlternative(undefined);
    }
  };

  const saveOpinion = () => {
    const data = {
      cpfCnpj: cpfCnpj,
      numeroProposta: proposalNumber,
      tipoDecisao: selectedDecision.value,
      tipoParecer: selectedOpinionType.codigo,
      motivoRejeicao: selectedDenyReason?.codigo,
      contrapartida: selectedAlternative?.codigo,
      statusProposta: selectedProposalStatus?.numeroProximoStatus,
      complementoDescricaoParecer: note,
      motivosRejeicao: selectedDenyReasons.map((motivo) => ({
        codigo: motivo.codigo,
        contrapartidas: (selectedAlternatives[motivo.codigo] || []).map(
          (c) => c.codigo
        ),
      })),
    };

    setLoading(true);
    api
      .post(`/api/front-credito/pareceres`, data)
      .then(() => {
        toast.success("Dados salvos com sucesso!");
        reloadOpinions();
        reloadEvents();
        reloadProposalPossibleStatuses();
        handleClose();
      })
      .catch(() => {
        toast.error("Erro ao salvar os dados.");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (open && size(denyReasons) === 0) {
      setDenyReasonsLoading(true);
      MotivoRejeicao.listFullData(true)
        .then((response) => {
          if (response.data) {
            setDenyReasons(response.data);
          }
        })
        .catch((e) => {
          toast.error("Erro ao carregar os motivos de rejeição");
          console.error("Erro ao carregar os motivos de rejeição", e);
        })
        .finally(() => {
          setDenyReasonsLoading(false);
        });
    }
  }, [open, denyReasons]);

  const disableSaveButton =
    !proposalNumber ||
    !selectedDecision ||
    !selectedOpinionType ||
    (requiredStatus &&
      (!selectedProposalStatus ||
        (selectedProposalStatus.exigirObservacao && !note))) ||
    (requiredDenyReason &&
      (!selectedDenyReasons.length ||
        selectedDenyReasons.some(
          (m) => !selectedAlternatives[m.codigo]?.length
        )));

  return (
    <Modal open={open} onClose={handleClose}>
      <Header>
        <IconWrapper>
          <ReactSVG src={FrontCredito} />
        </IconWrapper>
        <TitleWrapper>
          <Title>Front de crédito</Title>
          <Subtitle>Análise de Crédito</Subtitle>
        </TitleWrapper>
      </Header>
      <Body>
        <Label>Parecer</Label>
        <Card>
          <Grid container spacing={3}>
            <Grid item md={6}>
              <SearchableSelect
                entries={decisions}
                isDisabled={loading}
                label="Decisão"
                labelStyles={selectLabelStyles}
                parser={(it) => ({
                  value: it.value,
                  label: it.value + " - " + it.description,
                })}
                placeholder="Selecione"
                selected={selectedDecision}
                setSelected={handleChangeDecision}
              />
            </Grid>
            <Grid item md={12}>
              <SearchableSelect
                entries={opinionTypes}
                label="Tipo de parecer"
                labelStyles={selectLabelStyles}
                parser={(it) => ({
                  value: it.codigo,
                  label: `${it.codigo} - ${it.descricao}`,
                })}
                isLoading={opinionTypesLoading}
                isDisabled={loading}
                placeholder="Selecione"
                selected={selectedOpinionType}
                setSelected={setSelectedOpinionType}
              />
            </Grid>

            {requiredDenyReason && (
              <>
                <Grid item md={12}>
                  <SearchableMultipleSelect
                    entries={denyReasons}
                    label="Motivos de rejeição"
                    labelStyles={selectLabelStyles}
                    parser={(it) => ({
                      value: it.codigo,
                      label: it.descricao,
                    })}
                    isLoading={denyReasonsLoading}
                    placeholder="Selecione"
                    selectedOptions={selectedDenyReasons}
                    setSelectedOptions={(items) => {
                      setSelectedDenyReasons(items);
                      setSelectedAlternatives((prev) => {
                        const next = {};
                        items.forEach((m) => {
                          if (prev[m.codigo]) {
                            next[m.codigo] = prev[m.codigo];
                          }
                        });
                        return next;
                      });
                    }}
                  />
                </Grid>

                <Grid item md={12}>
                  {selectedDenyReasons.map((motivo, index) => (
                    <Grid
                      item
                      md={12}
                      key={motivo.codigo}
                      style={{ marginBottom: "10px" }}
                    >
                      <SearchableMultipleSelect
                        entries={motivo.contrapartes ?? []}
                        label={
                          <span>
                            Contra-partidas para{" "}
                            <strong>{motivo.descricao}</strong>
                          </span>
                        }
                        labelStyles={selectLabelStyles}
                        parser={(it) => ({
                          value: it.codigo,
                          label: it.descricao,
                        })}
                        placeholder="Selecione"
                        selectedOptions={
                          selectedAlternatives[motivo.codigo] || []
                        }
                        setSelectedOptions={(newValue) => {
                          setSelectedAlternatives((prev) => {
                            const updated = {
                              ...prev,
                              [motivo.codigo]: newValue,
                            };

                            const isFirstMotivo =
                              selectedDenyReasons[0]?.codigo === motivo.codigo;

                            if (isFirstMotivo) {
                              const prevList = prev[motivo.codigo] || [];
                              const added = newValue.find(
                                (nv) =>
                                  !prevList.some(
                                    (pv) => pv.codigo === nv.codigo
                                  )
                              );
                              const removed = prevList.find(
                                (pv) =>
                                  !newValue.some(
                                    (nv) => nv.codigo === pv.codigo
                                  )
                              );

                              selectedDenyReasons.slice(1).forEach((m) => {
                                const current = prev[m.codigo] || [];

                                if (added) {
                                  const match = m.contrapartes?.find(
                                    (c) => c.descricao === added.descricao
                                  );
                                  if (
                                    match &&
                                    !current.some(
                                      (c) => c.codigo === match.codigo
                                    )
                                  ) {
                                    updated[m.codigo] = [...current, match];
                                  }
                                }

                                if (removed) {
                                  const toRemove = m.contrapartes?.find(
                                    (c) => c.descricao === removed.descricao
                                  );
                                  if (toRemove) {
                                    updated[m.codigo] = current.filter(
                                      (c) => c.codigo !== toRemove.codigo
                                    );
                                  }
                                }
                              });
                            }

                            return updated;
                          });
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </>
            )}
            {requiredStatus && (
              <Grid item md={12}>
                <SearchableSelect
                  entries={proposalPossibleStatuses}
                  label="Status Proposta"
                  labelStyles={selectLabelStyles}
                  parser={(it) => ({
                    value: it.numeroProximoStatus,
                    label: it.descricao,
                  })}
                  isLoading={proposalPossibleStatusesLoading}
                  isDisabled={loading}
                  placeholder="Selecione"
                  selected={selectedProposalStatus}
                  setSelected={setSelectedProposalStatus}
                />
              </Grid>
            )}
            <Grid item md={12}>
              <Input
                label="Observação"
                value={note}
                disabled={loading}
                onChange={setNote}
                defaultValue=""
                height={200}
                type="textarea"
                align="flex-start"
              />
            </Grid>
          </Grid>
          <ButtonWrapper>
            <Button
              height="34px"
              width="120px"
              loading={loading}
              disabled={disableSaveButton}
              onClick={saveOpinion}
            >
              Salvar
            </Button>
          </ButtonWrapper>
        </Card>
      </Body>
    </Modal>
  );
};

const Header = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 3px solid #00a2e0;
`;

const IconWrapper = styled.div`
  width: 50px;
  height: 50px;

  svg {
    width: 50px;
    height: 50px;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;
  margin: 0px 5px;
`;

const Title = styled.div`
  font-size: 18px;
  font-family: Roboto;
  font-weight: bold;
  line-height: 1.22;
  color: #383838;
`;

const Subtitle = styled.div`
  font-size: 15px;
  font-family: Roboto;
  font-weight: 500;
  line-height: 1.2;
  color: #747576;
`;

const Body = styled.div`
  margin-top: 32px;
  width: 700px;
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 10px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
  margin-top: 32px;
`;

export default OpinionsModal;
